"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTagLink = exports.tagLinkStyle = exports.StyledLink = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var react_router_dom_1 = require("react-router-dom");
var styled_1 = require("../styled");
var mixins_1 = require("../../../../themes/mixins");
var themes_1 = require("../../../../themes");
var utilsOolib_1 = require("../../../../utilsOolib");
var greyColor100 = themes_1.colors.greyColor100, greyColor15 = themes_1.colors.greyColor15, red = themes_1.colors.red, invertRed = themes_1.colors.invertRed, green = themes_1.colors.green, invertGreen = themes_1.colors.invertGreen;
exports.StyledLink = (0, styled_components_1.default)(react_router_dom_1.NavLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
var tagLinkStyle = function (_a) {
    var variant = _a.variant, invert = _a.invert, color = _a.color, size = _a.size, colors = _a.theme.colors;
    switch (true) {
        case variant === 'primary':
            switch (color) {
                case 'red':
                    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            background-color: ", ";\n            ", "\n            ", "\n          "], ["\n            background-color: ", ";\n            ", "\n            ", "\n          "])), !invert ? red : invertRed, (0, styled_1.textColor)({ invert: invert }), (0, styled_1.redHover)({ invert: invert }));
                case 'green':
                    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            background-color: ", ";\n            ", "\n            ", "\n          "], ["\n            background-color: ", ";\n            ", "\n            ", "\n          "])), !invert ? green : invertGreen, (0, styled_1.textColor)({ invert: invert }), (0, styled_1.greenHover)({ invert: invert }));
                case 'black':
                    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            background-color: ", ";\n            ", "\n            ", "\n          "], ["\n            background-color: ", ";\n            ", "\n            ", "\n          "])), !invert ? greyColor100 : greyColor15, (0, styled_1.textColor)({ invert: invert }), (0, styled_1.blackHover)({ invert: invert }));
                default:
                    return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            background-color: ", ";\n            ", "\n            ", "\n          "], ["\n            background-color: ", ";\n            ", "\n            ", "\n          "])), !invert ? (0, utilsOolib_1.getPrimaryColor100)(colors) : (0, utilsOolib_1.getPrimaryColor40)(colors), (0, styled_1.textColor)({ invert: invert }), (0, styled_1.blueHover)({ invert: invert, colors: colors }));
            }
        default: // variant secondary
            return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        background: none;\n        border: ", " solid\n          ", ";\n        color: ", ";\n        ", "\n      "], ["\n        background: none;\n        border: ", " solid\n          ", ";\n        color: ", ";\n        ", "\n      "])), size === 'XS' ? '1px' : '2px', !invert ? (0, utilsOolib_1.getPrimaryColor100)(colors) : (0, utilsOolib_1.getPrimaryColor40)(colors), !invert ? (0, utilsOolib_1.getPrimaryColorText)(colors) : (0, utilsOolib_1.getPrimaryColor40)(colors), (0, styled_1.blueHover)({ invert: invert, colors: colors }));
    }
};
exports.tagLinkStyle = tagLinkStyle;
exports.StyledTagLink = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", ";\n"], ["\n  ", "\n  ", "\n  ", ";\n"])), function (_a) {
    var size = _a.size;
    return (0, styled_1.commonStyle)({ size: size });
}, function (props) { return (0, exports.tagLinkStyle)(props); }, (0, mixins_1.transition)('background-color', 'color'));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
